const hoverEvent = {
  state: {
    hovers: false
  },
  getters: {

  },
  mutations: {
    addHover (state, obj) {
      if (obj.now) {
        obj.ev.target.className = 'ivu-table-row-hover'
      } else {
        obj.ev.target.className = ''
      }
    }
  },
  actions: {

  }
}
export default hoverEvent



// WEBPACK FOOTER //
// ./src/store/modules/hoverEvent.js